import { FormControlLabel, Radio, RadioGroup, withStyles } from "@material-ui/core";
import Divider from "../../../../../../../../components/Divider/Divider";
import FlexColumn from "../../../../../../../../components/FlexBox/FlexColumn"
import FlexRow from "../../../../../../../../components/FlexBox/FlexRow";
import SButton from "../../../../../../../../components/SButton/SButton";
import Typography from "../../../../../../../../components/Typography/Typography";
import { colors } from "../../../../../../../../styles/colors";
import { CaretDownIcon, CaretUpIcon, TrashIcon } from "@phosphor-icons/react";

const StyledRadio = withStyles({
    root: {
        color: '#BDC7D9',
        '&$checked': {
            color: '#03BFFF',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const Board = ({ index, board, updateBoard, deleteBoard }) => {

    return (
        <FlexColumn alignItems="start" gap="0.5rem" styles={{ padding: '1rem', border: `1px solid ${colors.info700}`, borderRadius: '1rem' }}>
            <FlexRow flexWrap="nowrap">
                <FlexColumn gap="0.4rem" alignItems="start">
                    <Typography variant={"b1B"}>Downstream board {index + 1}</Typography>
                    <Typography variant={"b3R"} color={colors.grey400}><span style={{ marginRight: '1rem' }}>Port : 1</span>  Channels : 2</Typography>
                </FlexColumn>
                <SButton variant={"secondary"} style={{ width: '7rem' }} onClick={() => { updateBoard("opened", !board?.opened) }}>
                    {board?.opened ? "Collapse" : "Expand"}{!board?.opened ? <CaretDownIcon weight="bold" style={{ marginLeft: '0.2rem' }} size={14} /> : <CaretUpIcon weight="bold" style={{ marginLeft: '0.2rem' }} size={14} />}
                </SButton>
            </FlexRow>

            {board?.opened && <>
                <Divider />
                <FlexColumn gap="0.1rem" alignItems="start">
                    <Typography variant={"b3B"}>Port number</Typography>
                    <Typography variant={"b3R"} color={colors.grey300}>Select the port the downstream board is connected to</Typography>
                </FlexColumn>
                <RadioGroup style={{ flexDirection: 'row', gap: '1rem' }} aria-label="Port-Number" name="portNumber" value={board?.port} onChange={(e) => { updateBoard("port", e?.target?.value) }}>
                    <FormControlLabel value={"1"} control={<StyledRadio />} label="Port 1" />
                    <FormControlLabel value={"2"} control={<StyledRadio />} label="Port 2" />
                </RadioGroup>

                <FlexColumn gap="0.1rem" alignItems="start">
                    <Typography variant={"b3B"}>Number of Channels</Typography>
                    <Typography variant={"b3R"} color={colors.grey300}>Select the port the downstream board is connected to</Typography>
                </FlexColumn>
                <RadioGroup style={{ flexDirection: 'row', gap: '1rem' }} aria-label="Number-Of-channels" name="noOfChannels" value={board?.channels} onChange={(e) => { updateBoard("channels", e?.target?.value) }}>
                    <FormControlLabel value={"2"} control={<StyledRadio />} label="2" />
                    <FormControlLabel value={"4"} control={<StyledRadio />} label="4" />
                </RadioGroup>
                <FlexRow justifyContent="end">
                    <SButton style={{ padding: '0.2rem 1rem', borderRadius: '0.25rem' }} variant={"secondary"} color={"error"} size="small" onClick={() => { deleteBoard() }}>Delete</SButton>
                </FlexRow>
            </>}
        </FlexColumn>
    );
}

export default Board;
